import builder from '../builder';
import OfficeFilePpt from '../../streamline-icons/light/office-file-ppt.svg';

export default builder('IconOfficeFilePptLight', OfficeFilePpt);
